import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../common/Modal/Modal';
import ConfirmCyclicalReportForm from './ConfirmCyclicalReportForm';
var ConfirmCyclicalReportModal = function ConfirmCyclicalReportModal(props, context) {
  return React.createElement(Modal, {
    isOpen: props.isOpen,
    title: context.t('Schedule a Cyclical Report'),
    customClass: 'confirm-report-modal',
    close: props.close,
    footer: {
      buttonText: context.t('Schedule Report'),
      buttonStyle: 'additive',
      onClick: function onClick() {
        return props.scheduleReport(props.payload);
      }
    }
  }, React.createElement(ConfirmCyclicalReportForm, {
    payload: props.payload
  }));
};
ConfirmCyclicalReportModal.propTypes = {
  payload: PropTypes.object,
  close: PropTypes.func.isRequired
};
ConfirmCyclicalReportModal.defaultProps = {
  payload: {
    type: '',
    startDate: '',
    frequency: ''
  }
};
ConfirmCyclicalReportModal.contextTypes = {
  t: PropTypes.func.isRequired
};
export default ConfirmCyclicalReportModal;